import { initTestnetSDK, SuiRpc } from 'parrot-sui-sdk';
import { config } from '@config';
import { ParrotCurrentRpcNode } from '@models/global-setting.model';

const cacheRpc = localStorage.getItem('Parrot_Current_RPC');
let rpc = cacheRpc ? (JSON.parse(cacheRpc) as ParrotCurrentRpcNode).rpc : undefined;
rpc = rpc ? rpc : config.fullnode;

console.log('current rpc: ', rpc);

export const parrotCurrentRPC = rpc;
export const parrotClient = new SuiRpc({ url: rpc });

const parrotSdk = initTestnetSDK();
export default parrotSdk;
